import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import { FormWrapper, Title } from '../promotion.styles';

const PromoTestConfig = ({ showTestConfig, setShowTestConfig, emailTestConfigRef, handleTest }) => {
    return (
		<PopUp setShow={setShowTestConfig}>
			<FormWrapper >
                <Title>
					Testing: {showTestConfig.name}
				</Title>
                <Input style={{ width: '100%' }} name='email' label='Email' inputRef={emailTestConfigRef} placeholder='Enter email' />
            <ActionButton defaultText='Send test'  style={{ alignSelf: 'end' }} onClick={handleTest} />
            </FormWrapper>
		</PopUp>
	);
};

export default PromoTestConfig;
					